<script lang="ts" setup>
const props = defineProps({
  alignment: {
    default: 'left',
    type: String as PropType<CompanySocialsAlignment>,
  },
  hasTooltip: {
    default: false,
    type: Boolean,
  },
  max: {
    default: Number.POSITIVE_INFINITY,
    type: Number,
  },
  reorder: {
    default: true,
    type: Boolean,
  },
  size: {
    default: 'sm',
    type: String as PropType<CompanySocialsSize>,
  },
  socials: {
    default: () => ({}),
    type: Object as PropType<CompanyV2Socials>,
  },
  urls: {
    default: () => ({}),
    type: Object as PropType<CompanyV2Urls>,
  },
})

const order: ('linkedinSalesNavigator' | CompanySocialsKeys)[] = [
  'linkedin',
  'linkedinSalesNavigator',
  'facebook',
  'facebookGroup',
  'instagram',
  'twitter',
  'mastodon',
  'tiktok',
  'youtube',
  'discord',
  'pinterest',
  'github',
  'dribbble',
  'snapchat',
]

const { t } = useI18n()

const formattedSocials = computed(() => {
  const results = Object.entries(props.socials)
    .filter(([socialName]) => order.includes(socialName as CompanySocialsKeys))
    .flatMap(([socialName, socialData]) => {
      const result = [
        {
          name: socialName,
          url: socialData?.url || '',
        },
      ]

      return result
    })
    .sort((current, next) => {
      if (!props.reorder) {
        return 0
      }

      return order.indexOf(current.name as CompanySocialsKeys) - order.indexOf(next.name as CompanySocialsKeys)
    })
    .slice(0, props.max)

  // Add LinkedIn Sales Navigator if it exists in URLs
  if (props.urls.salesNavigator) {
    results.push({
      name: 'linkedinSalesNavigator',
      url: props.urls.salesNavigator,
    })
  }

  return results
})
</script>

<template>
  <div
    class="flex flex-wrap items-center"
    :class="{
      'justify-start': alignment === 'left',
      'justify-center': alignment === 'center',
      'justify-end': alignment === 'right',
      'gap-1.5': size === 'xs',
      'gap-2': size === 'sm',
    }"
  >
    <template
      v-for="social in formattedSocials"
      :key="social.name"
    >
      <UTooltip :text="hasTooltip ? t(`datapoints.attributes.socials-${social.name}`) : ''">
        <ULink
          :class="{
            'size-4': size === 'xs',
            'size-5': size === 'sm',
          }"
          :to="social.url"
        >
          <UIcon
            :class="{
              'size-4': size === 'xs',
              'size-5': size === 'sm',
            }"
            :name="getIcon(social.name as UIcon)"
          />
        </ULink>
      </UTooltip>
    </template>
  </div>
</template>
